<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img
        src="../../assets/images/pages/not-authorized.png"
        alt="graphic-not-authorized"
        class="mx-auto mb-4"
      />
      <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">You are in Authorizing!</h1>
      <p
        class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse"
      >Authorizing to use this service, please wait.</p>
      <h1 style="color:rgb(216, 83, 59)">{{resmessage}}</h1>
    </div>
  </div>
</template>

<script>
import axios from "./axios_auth";

export default {
  data() {
    return {
      ftoken: this.$route.params.id,
      authdb: this.$route.params.id2,
      appdb: this.$route.params.id3,
      token: null,
      ctoken: null,
      resmessage: null,
      appname: null
    };
  },
  methods: {
    deToken() {
      // let str1 = "12-33455/12345-5";

      let token = this.ftoken.split("|");
      let str = token[1];
      let stlen = str.length;
      let ttoken = token[3];
      this.token = ttoken;
      this.appname = token[4];

      let dg1, dg2, dg3, dg4, dg5, st1, st2, st3, st4, st5, st6, fstr;

      st1 = str.substr(0, 5);
      st2 = str.substr(6, 5);
      st3 = str.substr(11, 5);
      st4 = str.substr(16, 5);
      st5 = str.substr(21, 5);
      st6 = str.substr(26, stlen);

      dg1 = ttoken.substring(0, 1);
      dg2 = ttoken.substring(2, 3);
      dg3 = ttoken.substring(4, 5);
      dg4 = ttoken.substring(6, 7);
      dg5 = ttoken.substring(8, 9);

      fstr = st1 + dg1 + st2 + dg2 + st3 + dg3 + st4 + dg4 + st5 + dg5 + st6;

      return fstr;
    },
    authToken() {
      const formData = {
        remember_token: this.deToken(),
        token: this.token,
        appname: this.appname
      };
      axios
        .post("/ApiauthToken", formData)
        .then(res => {
          // console.log(res);

          if (res.data.status != "ok") {
            this.resmessage = "You Not Allow To Access, Please Back to Login";
          } else {
            const now = new Date();

            localStorage.setItem(
              "expiredIn",
              new Date(now.getTime() + 36000000)
            );
            localStorage.setItem("userRole", res.data.userRole);
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("dbname", res.data.dbname);
            localStorage.setItem("authurl", res.data.authurl);
            localStorage.setItem("comgroups_id", res.data.comgroups_id);

            let userRole = res.data.userRole;
            this.$store.dispatch("setuserRole", userRole);
            this.$acl.change(userRole);

            setTimeout(() => {
              this.$router.replace("/");
            }, 500);
          }
        })
        .catch(err => {
          // console.log(err);
          alert(err);
        });
    }
  },
  mounted() {},
  created() {
    // this.ctoken = this.deToken();
    setTimeout(() => {
      localStorage.setItem("authdb", "http://" + this.authdb + "/");
      localStorage.setItem("appdb", "http://" + this.appdb + "/");

      this.authToken();
    }, 500);
  }
};
</script>
